import { requestJson } from "./instateamEmployeeApi";

export function getNotifications(token, params = {}) {
  const searchParams = new URLSearchParams();
  if (params.category && params.category !== "all") searchParams.set("category", params.category);
  if (params.unread) searchParams.set("unread", "true");
  const suffix = searchParams.toString() ? `?${searchParams.toString()}` : "";

  return requestJson(`/instateam/notifications${suffix}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function markNotificationRead(token, notificationId = "all") {
  return requestJson(`/instateam/notifications/${notificationId}/read`, {
    method: "PATCH",
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function markNotificationCategoryRead(token, category) {
  const searchParams = new URLSearchParams();
  if (category) searchParams.set("category", category);
  const suffix = searchParams.toString() ? `?${searchParams.toString()}` : "";

  return requestJson(`/instateam/notifications/all/read${suffix}`, {
    method: "PATCH",
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function getNotificationSettings(token) {
  return requestJson("/instateam/notifications/settings", {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function updateNotificationSettings(token, payload) {
  return requestJson("/instateam/notifications/settings", {
    method: "PATCH",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}
